import { createFileRoute, Link } from "@tanstack/react-router";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Brain, ArrowRight, AlertCircle } from "lucide-react";

export const Route = createFileRoute("/ai/icd10-advisor")({
  component: Icd10AdvisorPage,
});

function Icd10AdvisorPage() {
  return (
    <div className="space-y-4 p-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight flex items-center gap-2">
          <Brain className="h-5 w-5" /> ICD-10 Advisor
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">Suggestion de codes CIM-10 assistée par IA · Mode conseil uniquement</p>
      </div>

      <div className="rounded-lg border border-amber-500/30 bg-amber-500/5 p-3 flex items-start gap-2 text-sm">
        <AlertCircle className="h-4 w-4 text-amber-400 mt-0.5 shrink-0" />
        <div className="text-amber-200/90">
          <strong>Rappel réglementaire :</strong> les suggestions ICD-10 générées par l'IA sont fournies
          à titre indicatif UNIQUEMENT. Le médecin clinicien doit valider tout diagnostic.
          L'IA n'est pas un outil diagnostique autonome.
        </div>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Module disponible</CardTitle>
          <CardDescription>L'interface ICD-10 Advisor est intégrée au module Consultation.</CardDescription>
        </CardHeader>
        <CardContent>
          <Button asChild>
            <Link to="/consultation">
              Ouvrir Consultation <ArrowRight className="h-3.5 w-3.5 ml-1" />
            </Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
